var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      { staticClass: "rc-info-tabs" },
      _vm._l(_vm.tabRefs, function (tab, key) {
        return _c(
          "li",
          {
            class: {
              active: tab.visible,
              "striped-link-on": tab.visible,
              "striped-link": !tab.visible,
            },
          },
          [
            _c(
              "a",
              {
                attrs: { role: "button", tabindex: "0" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.switchTab(key)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(tab.tabName) + "\n            "
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", [
      _vm.tabRefs.overview.visible
        ? _c(
            "div",
            { staticClass: "stats-tab-content" },
            [
              _c("stats-overview", {
                attrs: { "state-change": _vm.stateChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabRefs.mpas.visible
        ? _c(
            "div",
            { staticClass: "stats-tab-content" },
            [
              _c("stats-mpas-byelaws", {
                attrs: { "state-change": _vm.stateChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabRefs.habitats.visible
        ? _c(
            "div",
            { staticClass: "stats-tab-content" },
            [
              _c("stats-habitats", {
                attrs: { "state-change": _vm.stateChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabRefs.fishing.visible
        ? _c(
            "div",
            { staticClass: "stats-tab-content" },
            [
              _c("stats-fishing", {
                attrs: { "state-change": _vm.stateChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabRefs.condition.visible
        ? _c(
            "div",
            { staticClass: "stats-tab-content" },
            [
              _c("stats-condition", {
                attrs: { "state-change": _vm.stateChange },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }